import Swal from 'sweetalert2';
import { url } from '../api/api';
import { loadJWT } from './loadJWT';

export const loadServicesSupplier = async () => {
  let services = [];
  const { token } = loadJWT();
  await url
    .get(`/servicios-proveedores-completos?filter={"where": {"FechaBaja": null}}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response => {
      services = response.data.map(resp => resp);
    })
    .catch(e => {
      Swal.fire('Error', e?.response?.data?.error?.message || 'Error. Contacte con el administrador', 'error');
    });
  return services;
};
